var React = require('react');

function IconDesktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.556.778A3.559 3.559 0 0 0 0 4.333v16a3.559 3.559 0 0 0 3.556 3.556h9.777l-.594 1.778h-3.85c-.983 0-1.778.794-1.778 1.777 0 .984.795 1.778 1.778 1.778H23.11c.983 0 1.778-.794 1.778-1.777 0-.984-.795-1.778-1.778-1.778h-3.85l-.594-1.778h9.777A3.559 3.559 0 0 0 32 20.333v-16A3.559 3.559 0 0 0 28.444.778H3.556Zm24.888 3.555v12.445H3.556V4.333h24.888Z","fill":"currentColor"}));
}

IconDesktop.defaultProps = {"fill":"none","viewBox":"0 0 32 30"};

module.exports = IconDesktop;

IconDesktop.default = IconDesktop;
